export default [
    {
        name: "bianco",
        img: "bianco.png",
        topings: "olive oil, garlic, olives, rocket, parmesan, tomato",
        standardPrice: "11",
        famillyPrice: "19"
    },
    {
        name: "margarita",
        img: "margarita.png",
        topings: "tomato sauce, cheese, parmesan, basil, olives",
        standardPrice: "16",
        famillyPrice: "25"
    },
    {
        name: "light",
        img: "light.png",
        topings: "olive oil, cheese, tomatoes, basil, rocket, olives",
        standardPrice: "16",
        famillyPrice: "25"
    },
    {
        name: "funghi",
        img: "funghi.png",
        topings: "tomato sauce, cheese, mushrooms , olives, dried boletus",
        standardPrice: "16",
        famillyPrice: "25"
    },
    {
        name: "vegetariano",
        img: "vegetariano.png",
        topings: "cheese, mushrooms, olives, tomatoes, rocket, pepper, red onion",
        standardPrice: "16",
        famillyPrice: "26"
    },
    {
        name: "capricciosa",
        img: "capricciosa.png",
        topings: "tomato sauce, cheese, ham, tomatoes, mushrooms, olives",
        standardPrice: "17",
        famillyPrice: "27"
    },
    {
        name: "vesuvio",
        img: "vesuvio.png",
        topings: "tomato sauce, cheese, ham, tomatoes, olives",
        standardPrice: "17",
        famillyPrice: "27"
    },
    {
        name: "parma",
        img: "parma.png",
        topings: "tomato sauce, cheese, ham, mushrooms, parmesan, tomatoes, olives",
        standardPrice: "19",
        famillyPrice: "30"
    },
    {
        name: "serbiana",
        img: "serbiana.png",
        topings: "tomato sauce, cheese, bacon, mushrooms, sour cream, sausage, hot peppers",
        standardPrice: "19",
        famillyPrice: "29"
    },
    {
        name: "quatro stagione",
        img: "quatro-stagione.png",
        topings: "tomato sauce, cheese, ham, sausage, ham, sour cream, mushrooms, tomatoes, rocket, olives, egg",
        standardPrice: "20",
        famillyPrice: "31"
    },
    {
        name: "quatro formaggi",
        img: "quatro-formaggi.png",
        topings: "tomato sauce, parmesan, mozzarella, olives smoked cheese, gorgonzola, walnuts, tomatoes",
        standardPrice: "19",
        famillyPrice: "30"
    },
    {
        name: "ciao",
        img: "ciao-pizza.png",
        topings: "tomato sauce, cheese, mushrooms, prosciutto, olives, parmesan, rocket",
        standardPrice: "20",
        famillyPrice: "32"
    },
    {
        name: "el toro",
        img: "el-toro.png",
        topings: "tomato sauce, beef ham, mushrooms, olives, cheese, cheese, red onion",
        standardPrice: "20",
        famillyPrice: "32"
    },
    {
        name: "nlo",
        img: "nlo.png",
        topings: "olive oil, tomatoes, prosciutto, ham cheese, mushrooms, sour cream olives, parmesan",
        standardPrice: "30",
        famillyPrice: "49"
    },
    {
        name: "maiale nero",
        img: "maiale-nero.png",
        topings: "pizza with mango sausage, cheese, cherries, broccoli, olive oil",
        standardPrice: "19",
        famillyPrice: "30"
    },
    {
        name: "salmon",
        img: "salmon.png",
        topings: "olive oil, cheese, smoked salmon, rosemary, tomatoes, rocket, red onion",
        standardPrice: "23",
        famillyPrice: "34"
    },
    {
        name: "frutti di mare",
        img: "frutti-di-mare.png",
        topings: "tomato sauce, mushrooms, seafood, lemon, olive oil, olives, garlic, rocket, tomatoes",
        standardPrice: "21",
        famillyPrice: "30"
    },
    {
        name: "mediterraneo",
        img: "mediterraneo.png",
        topings: "tomato sauce, mushrooms, tuna, rocket, olives, anchovies, olive oil, tomatoes, garlic, lemon",
        standardPrice: "19",
        famillyPrice: "29"
    },
    {
        name: "del capricorno donna",
        img: "del-capricorno-donna.png",
        topings: "tomatoes, goat cheese, olive oil, raisins in brandy and honey, spinach, walnut, cherry",
        standardPrice: "20",
        famillyPrice: "32"
    },
    {
        name: "gorgonzola",
        img: "gorgonzola.png",
        topings: "tomato, cheese, olives, gorgonzola, walnut, fresh tomatoes",
        standardPrice: "20",
        famillyPrice: "30"
    }
]